import { shallowEqual, useSelector } from 'react-redux';
const useCurrentUser = () => {
    return useSelector(state => state?.users?.current, shallowEqual);
}

export default useCurrentUser;